import { createContext, createElement, useContext, type ReactNode } from 'react';

export type PlanningNavigationContextValue = {
  openNavigation: () => void;
};

const PlanningNavigationContext = createContext<PlanningNavigationContextValue | null>(null);

export function PlanningNavigationProvider({
  value,
  children,
}: {
  value: PlanningNavigationContextValue;
  children: ReactNode;
}) {
  return createElement(PlanningNavigationContext.Provider, { value }, children);
}

export function usePlanningNavigation() {
  return useContext(PlanningNavigationContext);
}
